import browserHistory from 'shared/history';
import {createItem, deleteItem, updateItem} from 'shared/portfolio/actions/time-sensitive-items';
import {errorMessage, flashMessage} from 'shared/actions/notifications';
import {closeActivityModalPath} from '../utils';

const FIELDS = [
  'completedAtDay',
  'completedAtYear',
  'completedAtMonth',
  'timeSensitiveItemTypeId',
  'title',
  'details',
  '_type',
].join(',');

export const createTimeSensitiveItem = (values, _id) => (dispatch) =>
  dispatch(createItem(values, FIELDS))
    .then(() => {
      browserHistory.replace(closeActivityModalPath());
      dispatch(flashMessage('Nice! Your achievement has been saved.'));
    })
    .catch(() => {
      dispatch(errorMessage());
    });

export const updateTimeSensitiveItem = (id, values) => (dispatch) =>
  dispatch(updateItem(id, values, FIELDS))
    .then(() => {
      browserHistory.replace(closeActivityModalPath());
      dispatch(flashMessage('Nice! Your achievement has been updated.'));
    })
    .catch(() => {
      dispatch(errorMessage());
    });

export const deleteTimeSensitiveItem = (id) => (dispatch) =>
  dispatch(deleteItem(id))
    .then(() => {
      browserHistory.replace(closeActivityModalPath());
      dispatch(flashMessage('College success item successfully removed.'));
    })
    .catch(() => {
      dispatch(errorMessage());
    });
